import axios from "axios";
import Vue from 'vue'

const apiUrl = `${process.env.VUE_APP_baseUrl}`;
const devInstance = createInstance(apiUrl);
const productionInstance = createInstance("http://localhost:3000"); // will change later
const instance = {};
function createInstance(baseURL){
    console.log(`Creating http instance with baseUrl = ${apiUrl}`)
    let instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            timeout: 360000
        }
    });
    instance.interceptors.request.use(
        (request) => requestHandler(request),
        (error) => errorHandler(error)
    );
    instance.interceptors.response.use(
        (response) => responseHandler(response),
        (error) => errorHandler(error)
    );

    return instance;
}
const requestHandler = request => {
     let token;
    token = vm.$store.getters['authModule/api_idtoken'];
 
    if ( token == undefined || token == null){
       // try to silently acquire a new token
     //  console.log("[customAxios.js] No Id Token - Need to get new one");
       let newusr = auth.user();
       //console.log(`customAxios called auth.js to get a new token: ${newusr}`)
     
       token = vm.$store.getters['authModule/api_idtoken'];
       //localStorageService.setIdToken(token);
        throw new Error('no token');

    } 
    request.headers.Authorization = `Bearer ${token}`;  
    return request;
}

const responseHandler = response => {
    if (response.status === 401) {
        window.location = '/login';
    }

    return response;
};
const errorHandler = error => {
    return Promise.reject(error);
};


export default {
    install () {
        let apiUrl = `${process.env.VUE_APP_baseUrl}`;
        this.instance = createInstance(apiUrl);
        Vue.prototype.$http = this.instance;
    }
}; // Check debug/build mode